import { render, staticRenderFns } from "./extrainfo.vue?vue&type=template&id=e065bab8&scoped=true&"
import script from "./extrainfo.vue?vue&type=script&lang=js&"
export * from "./extrainfo.vue?vue&type=script&lang=js&"
import style0 from "./extrainfo.vue?vue&type=style&index=0&id=e065bab8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e065bab8",
  null
  
)

export default component.exports